import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';

export function useQueryString() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useState<URLSearchParams | null>(
    null
  );
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    const search = new URLSearchParams(url.origin);
    setSearchParams(search);
  }, [location]);
  return {
    searchParams,
    hasSearchParams: !(searchParams?.size && searchParams?.size > 0)
  };
}
